import { ApiClient } from '@/lib/axios/client';
import type {
  CreateMasterDataFieldDefinitionDto,
  MasterDataFieldDefinition,
  UpdateMasterDataFieldDefinitionDto,
} from './types';

export class MasterDataFieldDefinitionsApi {
  static async list(orgId: string, dataset: string): Promise<MasterDataFieldDefinition[]> {
    return ApiClient.get<MasterDataFieldDefinition[]>(
      `/api/v1/orgs/${orgId}/master-data/fields?dataset=${encodeURIComponent(dataset)}`
    );
  }

  static async create(orgId: string, dto: CreateMasterDataFieldDefinitionDto): Promise<MasterDataFieldDefinition> {
    return ApiClient.post<MasterDataFieldDefinition>(
      `/api/v1/orgs/${orgId}/master-data/fields`,
      dto
    );
  }

  static async update(orgId: string, fieldId: number, dto: UpdateMasterDataFieldDefinitionDto): Promise<MasterDataFieldDefinition> {
    return ApiClient.patch<MasterDataFieldDefinition>(
      `/api/v1/orgs/${orgId}/master-data/fields/${fieldId}`,
      dto
    );
  }

  static async remove(orgId: string, fieldId: number): Promise<void> {
    return ApiClient.delete(`/api/v1/orgs/${orgId}/master-data/fields/${fieldId}`);
  }
}
